import { render, staticRenderFns } from "./exhibition-item.vue?vue&type=template&id=65c2fbd0&scoped=true&"
import script from "./exhibition-item.vue?vue&type=script&lang=js&"
export * from "./exhibition-item.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-item.vue?vue&type=style&index=0&id=65c2fbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2fbd0",
  null
  
)

export default component.exports